import dialogConfig, { AlmeDialogConfig } from "../../AlmeDialog/AlmeDialogConfig";

interface LiveChatControlsConfig extends AlmeDialogConfig {
    buttonText: string;
    defaultOperatorName: string;
    typingMessageText: string;
    typingMessageDelay?: number;
}

export interface AlmeLiveChatControlsConfig {
    liveChatControls: LiveChatControlsConfig;

}

/**
 * This is the baseline live chat controls config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeLiveChatControlsConfig = {
    liveChatControls: {
        buttonText: 'End Chat',
        defaultOperatorName: 'Operator',
        typingMessageText: 'is typing',
        typingMessageDelay: 3000,
        dialog: {
            ...dialogConfig.dialog,
        },
    },

};

export default defaultConfig;